import CustomModalSettings from "./CustomModalSettings";

export default CustomModalSettings;
